<template>
    <div class="common-items-center" ref="items-center">
        <div v-for="(item,index) in listMenuList" :key="index">
            <div v-if="(menuSonID == item.menuSonID)"  class="common-items-center" >
                <div class="btn active" :style='{height:heightNva+"px",lineHeight:heightNva+2+"px"}'>
                    <span>{{item.title}}</span>
                    <i class="el-icon-circle-close" @click="downBtn(index)"></i>
                </div>
            </div> 
            <div  v-else class="common-items-center">
                <div class="btn" :style='{height:heightNva+"px",lineHeight:heightNva+2+"px"}'>
                    <span  @click="tabBtn(index)">{{item.title}}</span>
                    <i class="el-icon-circle-close" @click="colesBtn(index)"></i>
                </div>
            </div> 
        </div>
    </div>
</template>
<script>
   export default{
     data:()=>({
        menuSonID:0,
        heightNva:40,
        listMenuList:[]
     }),
     created(){
        setInterval(res=>{
            let objectItem = localStorage.getItem("menuBtnVav")
                if(!objectItem){
                    return
                } 
            this.menuID = JSON.parse(objectItem).menuID 
            this.menuSonID = JSON.parse(objectItem).menuSonID 
            this.listMenuList = JSON.parse(objectItem).listMenuList
            this.menuList = JSON.parse(objectItem).menuList
            this.mark = JSON.parse(objectItem).mark
            this.heightNva = this.$store.state.blockNavHeight
        },1) 
     },
     methods:{
        //关闭navBtn 目前为选中的状态 
        downBtn(index){
            if(index!=0){
                //跳转到前面的一个数组
                this.$router.replace({
                    path:this.listMenuList[index-1].url,
                    query:{}
                })
                //设置信息
                let parms = {
                    menuList:this.menuList,                                  //切换的菜单
                    menuID: this.listMenuList[index-1].menuID,               //菜单主模块标志
                    menuSonID: this.listMenuList[index-1].menuSonID,         //菜单子模块标志
                    listMenuList:this.listMenuList,                          //横向菜单
                    mark:this.mark                                           //选中的平台
                }
                parms.listMenuList.splice(index,1)
                localStorage.setItem("menuBtnVav",JSON.stringify(parms)) 
            }else{
                if(this.listMenuList.length>1){
                    //跳转到前面的一个数组
                    this.$router.replace({
                        path:this.listMenuList[index+1].url,
                        query:{}
                    })
                    //设置信息
                    let parms = {
                        menuList:this.menuList,                                  //切换的菜单
                        menuID: this.listMenuList[index+1].menuID,               //菜单主模块标志
                        menuSonID: this.listMenuList[index+1].menuSonID,         //菜单子模块标志
                        listMenuList:this.listMenuList,                          //横向菜单
                        mark:this.mark                                           //选中的平台
                    }
                    parms.listMenuList.splice(index,1)
                    localStorage.setItem("menuBtnVav",JSON.stringify(parms)) 
                }  
            }
        },
        //切换navBtn
        tabBtn(index){
            let parms = {
                    menuList:this.menuList,                                  //切换的菜单
                    menuID: this.listMenuList[index].menuID,                 //菜单主模块标志
                    menuSonID: this.listMenuList[index].menuSonID,           //菜单子模块标志
                    listMenuList:this.listMenuList,                          //横向菜单
                    mark:this.mark                                           //选中的平台
            }
            localStorage.setItem("menuBtnVav",JSON.stringify(parms)) 
            //跳转到当前的一个Url
            this.$router.replace({
                path:this.listMenuList[index].url,
                query:{}
            })
        },
          //关闭未选中的
         colesBtn(index){
            //设置信息
            let parms = {
                menuList:this.menuList,            //切换的菜单
                menuID: this.menuID,               //菜单主模块标志
                menuSonID: this.menuSonID,         //菜单子模块标志
                listMenuList:this.listMenuList,    //横向菜单
                mark:this.mark                     //选中的平台
            }
            parms.listMenuList.splice(index,1)
            localStorage.setItem("menuBtnVav",JSON.stringify(parms)) 
         },
         leftFun(ev){
            this.$refs['items-center'].scrollLeft -= ev;
         },
         rightFun(ev){
            this.$refs['items-center'].scrollLeft += ev;
         }
       }
    }
</script>
<style scoped>
.slider {
  position: relative;
}
.arrow-left {
  left: 0;
}

.arrow-right {
  right: 0;
}
    .common-items-center{
        cursor: pointer;
        height: 100%;
        overflow-x: scroll;
        overflow-y: hidden;
        width: 100%;
    }
    .common-items-center::-webkit-scrollbar {
        display: none;
    }
    .btn{
         border-radius: 8px 8px 0 0;
         height:100%;
         padding:0 20px 0 15px;
         background-color: #E5EBF8;  
         font-family: PingFangSC-Regular;
         font-size: 14px;
         color: #4D5C72;
         letter-spacing: 0;
         margin-right:6px;
         white-space: nowrap;
      }
      .btn.active{
         background-color: white;  
         color: #1873FF;
      }
      .el-icon-circle-close{
         position: relative;
         left: 8px;
      }

</style>